// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ITmcColumnCount {
	columnKey: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class TmcColumnCount {
	constructor(data?: ITmcColumnCount) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	columnKey: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.Reports.TmcColumnCount, ";
	$type?: string | undefined = TmcColumnCount.$type;
}

